import { BrowserRouter as Router, Switch } from "react-router-dom";

import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import Routes from "./Routes";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Switch>
          <Routes />
        </Switch>
      </Layout>
    </Router>
  );
}

export default App;
